import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  minutes: number;
};
const purchases: Purchase[] = [{
  name: 'Daniela H.',
  city: 'Córdoba',
  minutes: 7
}, {
  name: 'Martín G.',
  city: 'Buenos Aires',
  minutes: 12
}, {
  name: 'Lucía F.',
  city: 'Rosario',
  minutes: 3
}, {
  name: 'Nicolás P.',
  city: 'Mendoza',
  minutes: 20
}, {
  name: 'Valentina S.',
  city: 'La Plata',
  minutes: 5
}, {
  name: 'Federico R.',
  city: 'Mar del Plata',
  minutes: 15
}, {
  name: 'Camila T.',
  city: 'Salta',
  minutes: 9
}, {
  name: 'Ignacio M.',
  city: 'Tucumán',
  minutes: 18
}, {
  name: 'Sofía A.',
  city: 'Neuquén',
  minutes: 4
}, {
  name: 'Tomás B.',
  city: 'San Juan',
  minutes: 11
}];
const DISPLAY_DURATION = 8500;
const ROTATION_INTERVAL = 20000;
const DISMISS_DELAY = 30000;
export function VerifiedPurchasePopup() {
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const rotation = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setPurchaseIndex(current => getNextIndex(current));
        setIsVisible(true);
      }, 350);
    }, ROTATION_INTERVAL);
    return () => window.clearInterval(rotation);
  }, []);
  useEffect(() => {
    if (isVisible) {
      const hide = window.setTimeout(() => setIsVisible(false), DISPLAY_DURATION);
      return () => window.clearTimeout(hide);
    }
    return undefined;
  }, [isVisible, purchaseIndex]);
  function handleDismiss() {
    setIsVisible(false);
    window.setTimeout(() => {
      setPurchaseIndex(current => getNextIndex(current));
      setIsVisible(true);
    }, DISMISS_DELAY);
  }
  const purchase = purchases[purchaseIndex];
  return <AnimatePresence data-id="element-239" data-mp="18l5ykeb6gtln">
      {isVisible && <motion.aside key={purchase.name} role="status" aria-live="polite" initial={{
      opacity: 0,
      x: -20,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -20,
      y: 12
    }} transition={{
      duration: 0.28,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="fixed bottom-4 left-4 z-50 w-[calc(100vw-2rem)] max-w-sm rounded-xl border border-brand/40 bg-black p-4 pr-10 shadow-2xl shadow-black/50 sm:bottom-6 sm:left-6" data-id="element-240" data-mp="18jusu8y69brw">
          <button type="button" onClick={handleDismiss} aria-label="Cerrar notificación de compra" className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-md text-gray-500 transition-colors hover:bg-white/5 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-241" data-mp="1acnq10x95zer">
            <XIcon className="h-4 w-4" data-id="element-242" data-mp="1o9stct5l0k6b" />
          </button>

          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-243" data-mp="2urfx8zletjvn">
            <span className="relative flex h-2 w-2" data-id="element-244" data-mp="2zq0xgz0nw3k3">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-60" data-id="element-245" data-mp="o3peb94x3qnu" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" data-id="element-246" data-mp="j4cihyw2j994" />
            </span>
            Compra verificada
          </p>
          <p className="mt-3 text-sm leading-relaxed text-gray-200" data-id="element-247" data-mp="eccn8jqy14iv">
            <span className="font-semibold text-white" data-id="element-248" data-mp="9e1dsa4k8w16">{purchase.name}</span> de{' '}
            <span className="font-semibold text-white" data-id="element-249" data-mp="5dr5urx7jvjo">{purchase.city}</span> compró
            Capital Consciente <span aria-hidden="true" data-id="element-250" data-mp="e4r2e1qe78r">🏆</span>
          </p>
          <p className="mt-2 text-xs text-gray-500" data-id="element-251" data-mp="gqzefwg4qs1">hace {purchase.minutes} minutos</p>
        </motion.aside>}
    </AnimatePresence>;
}
function getNextIndex(currentIndex: number) {
  let nextIndex = Math.floor(Math.random() * purchases.length);
  if (purchases.length > 1 && nextIndex === currentIndex) {
    nextIndex = (nextIndex + 1) % purchases.length;
  }
  return nextIndex;
}